import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { getTopImage } from '../util/Helper';

class ItemLoggedIn extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      moreInfoShown:false
     }
  }
  
  handleSubmitClick = (e, id) => {
    e.preventDefault();this.props.history.push("/termekregisztracio?termek=" + id)
  }
  handleEditClick = (e, id) => {
    e.preventDefault();
    this.props.history.push("/termekszerkesztes?termek=" + id)
  }

  gotoItemPage(id){
    //console.log("go to item page:" + id);
    this.props.history.push("/termek?id=" + id)
  }

  moreInfo = () =>{
    this.setState({moreInfoShown:true});
  }
  lessInfo = () =>{
    this.setState({moreInfoShown:false});
  }

  isAfterDeadline(){
    var yeasterday = new Date();
    yeasterday.setDate(new Date().getDate()-1);
    return new Date(this.props.item.deadline) < yeasterday;
  }
  getStatuses(regs){
    if(regs.length === 0) return "";
    let textSpans = [(<span key="cultureItem">{regs[0].name + " "} </span>)];
    for(let r in regs){
      //console.log("r:"+r + ",regs:"+regs.length);
      let reg= regs[r];
      if(reg.status){
        //console.log("reg.status:", reg);
        if(!reg.evaluation) continue;
        let color = (reg.status==='Jóváhagyva')?"#5E9D4C":(reg.status==='Elutasítva')?"#B24047":"#444";
        let text = (reg.status==='Jóváhagyva')?"Elfogadva":(reg.status==='Elutasítva')?"Elutasítva":"";
        textSpans.push(<span key={"cultureSpan"+r} style={{color:color}}>
          {this.capitalize(reg.usage_cultures)} ({text}){(r<regs.length-1)?", ":" "}</span>);
      }
    }
    return textSpans;
  }

  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  getPositionOfFader(){

    return (this.props.item.problem_name.indexOf("Foszfor hiány")>=0)?
        {position:'absolute', bottom:13}:
        {position:'absolute', top:0};
  }

  render() { 
    let colorClass = "kwizda-item-color-" + this.props.item.color.replace("#","");
    //console.log("name:" + this.props.item.name);
    
    return ( 
      <div className="kwizda-item" style={{height:'auto'}}>
          <div className={"kwizda-item-header "}>
            <div className="kwizda-item-top-container">
                {/*<h4><ItemName name={this.props.item.name} imageheight={26}></ItemName></h4>*/}
                {this.props.item.id && Number(this.props.item.id) < 23 ?
                  <img alt='cimke' className="kwizda-item-top-container-image" src={"img/kwizda3_cimkek/" + getTopImage(this.props.item.id)}/>
                  :
                  <div style={{width: '100%', height: 257, borderRadius: 25, position:'relative'}} className={colorClass}>
                    <img alt='cimke' className="kwizda-item-top-container-image testaaa" src={"img/kwizda3_cimkek/nezzuk_kiserletek_thumbnail.png"}/>
                    <div style={{position:'absolute', top:85, left:50, fontSize: 22, fontFamily: 'Muli-Bold', inlineSize: 158, overflowWrap: "break-word", lineHeight:'23px'}} >{this.props.item.name}</div>
                  </div>
                }
              </div>
          </div>
          <div className="kwizda-item-desc">
            {!(this.props.item.regid || this.props.item.regs) && 
              <div className="kwizda-item-container">
                <div style={{display:'none'}}><button onClick={(e)=> this.handleSubmitClick(e, this.props.item.id)}>Regisztráció</button>
                </div>

                <div className="kwizda-item-problem">{this.props.item.problem_name}</div>
                <div className="kwizda-item-culturesandusage"  style={{minHeight:20}}>
                  <div className="kwizda-item-label">Kísérlet megvalósítás időzítése:</div>
                  <div>{this.props.item.proposed_time}</div>
                  <div className="kwizda-item-label">Megvalósítás helye:</div>
                  <div>{this.props.item.agent}</div>
                  <div className="kwizda-item-label">Helyszínek száma:</div>
                  <div>{this.props.item.dose}</div>
                  <div className="kwizda-item-label">Dokumentáció módja:</div>
                  <div>{this.props.item.type}</div>
                </div>
                <div className="kwizda-item-gotopagebutton" onClick={() =>this.gotoItemPage(this.props.item.id)}>
                  <span>Kísérlet részletei itt!</span>
                </div>
              </div>
            }
            {(this.props.item.regid || this.props.item.regs) && 
              <div className="kwizda-item-container">
                {this.props.item.status === "Jóváhagyva" && this.props.item.evaluation  ? 
                  <div className="kwizda-status-container">
                      <div className="kwizda-status-image-container"><img src="img/termek_elfogadva.png" alt="Elfogadva"></img></div>
                      <div className="kwizda-status-desc">
                      <span>Pályázatát jóváhagytuk !</span>
                      </div>
                  </div>
                  :
                  this.props.item.status === "Elutasítva" && this.props.item.evaluation ? 
                  <div className="kwizda-status-container">
                      <div className="kwizda-status-image-container"><img src="img/termek_elutasitva.png" alt="Elutasítva"></img></div>
                      <div className="kwizda-status-desc">
                      <span>Pályázatát elutasítottuk: {(this.props.item.regs)?this.getStatuses(this.props.item.regs):""}</span> 
                      Amennyiben részletes tájékoztatást szeretne kérjük írjon az alábbi email címre: 
                      <a className="kwizda3-link" href="mailto:office@muchmore.hu">office@muchmore.hu</a></div>
                  </div>
                  :
                  this.props.item.regs ? 
                  <div className="kwizda-status-container">
                      <div className="kwizda-status-image-container"><img src="img/termek_reszben_elfogadva.png" alt="Részben elbírálva"></img></div>
                      <div className="kwizda-status-desc">
                        <span>Pályázatát részben elbíráltuk {this.getStatuses(this.props.item.regs)} kísérlet kapcsán. </span>
                      </div>
                  </div>
                  :
                  <div className="kwizda-status-container">
                      <div className="kwizda-status-image-container"><img src="img/termek_ertekeles_alatt.png" alt="Értékelés alatt"></img></div>
                      <div className="kwizda-status-desc">Pályázata értékelés alatt: hamarosan emailben is értesítést kap az elbírálásról</div>
                  </div>
                }
                <div className="kwizda-item-problem" style={{ color:'grey', position:'relative', overflow:'hidden'}}>
                  <span>{this.props.item.problem_name}</span>
                  <div style={this.getPositionOfFader()}>
                    <img style={{display:(this.state.moreInfoShown)?'none':'block'}}
                     src="img/read_more_section.png" alt="Kattintson a további információkért"></img>
                  </div>
                </div>
                {!this.state.moreInfoShown?
                <div className="kwizda-item-moreinfo" onClick={()=>this.moreInfo()} >
                  <span className="kwizda3-link" >Kattintson a további információkért</span>
                </div>
                :
                <div>
                  <div className="kwizda-item-culturesandusage">
                  <div className="kwizda-item-label">Kísérlet megvalósítás időzítése:</div>
                  <div>{this.props.item.proposed_time}</div>
                  <div className="kwizda-item-label">Megvalósítás helye:</div>
                  <div>{this.props.item.agent}</div>
                  <div className="kwizda-item-label">Helyszínek száma:</div>
                  <div>{this.props.item.dose}</div>
                  <div className="kwizda-item-label">Dokumentáció módja:</div>
                  <div>{this.props.item.type}</div>
                </div>
                </div>
                }
              </div>
            }
            
            <div className="kwizda-status-rectangle" style={{backgroundColor:'#F8B54C'}}>
            {this.props.item.status === "Jóváhagyva"  && this.props.item.evaluation  ? 
                  <div className="kwizda-status-container2-approved">Pályázatát jóváhagytuk</div>
                  :
                  this.props.item.status === "Elutasítva"  && this.props.item.evaluation  ? 
                  <div className="kwizda-status-container2-denied">Pályázatát elutsítottuk</div>
                  :
                  this.props.item.regs ? 
                  <div className="kwizda-status-container2-semipending">Pályázatát részben elbíráltuk</div>
                  :
                  this.props.item.regid ? 
                  <div className="kwizda-status-container2-pending">Pályázata értékelés alatt</div>
                  :
                  this.isAfterDeadline() ? 
                  <div className="kwizda-status-container2-closed">A regisztráció lezárult</div>
                  :
                  <div>
                    <button className="kwizda-button" 
                      style={{width:'100%', fontFamily:'Muli-Black'}} 
                      onClick={(e)=> this.handleSubmitClick(e, this.props.item.id)}>Kiválasztom</button>
                  </div>
                  
                }
            </div>
            
          </div>
          
          <div className="kwizda-item-deadline2" style={{position:'inherit'}}>
            <div>Jelentkezési határidő: {this.props.item.deadline}</div>
          </div>
      </div>
     );
  }
}
 
export default withRouter(ItemLoggedIn);
